export default {
	getAll(dto) {
        return DMUtils.http({
            method: 'POST',
            url: '/Intermediary/GetAll',
            data: dto,
        });
    },
    getAllDropdown() {
        return DMUtils.http({
            method: 'GET',
            url: '/Intermediary/GetAllDropdown',
        });
    },
    getByID(intermediaryID) {
        if (!intermediaryID) {
            intermediaryID = -1;
        }

        return DMUtils.http({
            method: 'GET',
            url: '/Intermediary/GetByID',
            params: { IntermediaryID : intermediaryID },
        });
    },
    create(dto) {
        if (!dto.PrimarySponsorID) {
            dto.PrimarySponsorID = -1;
        }     

        if (!dto.MinResponsesForDashboard) {
            dto.MinResponsesForDashboard = 0;
        }

        return DMUtils.http({
            method: 'POST',
            url: '/Intermediary/Create',
            data: dto
        });
    },
    update(dto) {       
        if (!dto.IntermediaryID) {
            dto.IntermediaryID = -1;
        }
        
        if (!dto.PrimarySponsorID) {
            dto.PrimarySponsorID = -1;
        }

        if (!dto.MinResponsesForDashboard) {
            dto.MinResponsesForDashboard = 0;
        }

        return DMUtils.http({
            method: 'POST',
            url: '/Intermediary/Update',
            data: dto,
        });
    },
    getSponsorOptions() {
        return DMUtils.http({
            method: 'GET',
            url: '/Sponsor/GetAllDropdown',
        });
    },
}